// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"88863a52","455":"79cc9976","977":"6093e56d"}[chunkId] + ".chunk.js";
};